<template lang="pug">
div.quick-edit-payout
	template(v-if="payoutRows.length")
		.cpa-payout-line(
			v-for="line in payoutRows",
			:key="line.key"
		)
			// Option 1: Editable: label + quick-edit bound to r[field] (payout or cpa_payout_<idx>)
			template(v-if="canEdit")
				span.cpa-payout-edit-row
					span.cpa-event-name(v-if="line.title") {{ line.title }}:
					quick-edit(:r="r", :field="line.field", @on-save="onSave")
			// Option 2: Read-only
			span.cpa-payout-readonly(v-else)
				span.cpa-event-name(v-if="line.title") {{ line.title }}:
				span.cpa-payout-value {{ line.payout }}
	// CPA with no fixed payable events — show 0 (matches list behaviour)
	span.cpa-payout-value(v-else) 0
</template>
<script>

export default {
	name: 'QuickEditPayout',
	props: {
		r: {
			type: Object,
			required: true,
		},
	},
	computed: {
		USER() {
			return this.$authStore.user;
		},
		canEdit() {
			const hasPermission = !!this.USER?.features?.allowEditPayout;
			const isApiOffer = !!this.r.external_id;
			const manualPayout = !this.r.auto_payout;
			const advertiseAPIEnabled = !!this.r.fetch_api_override_events;
			const isUpdatedViaAPI = isApiOffer && advertiseAPIEnabled && !manualPayout;
			
			return hasPermission && !isUpdatedViaAPI;
		},
		// Each line: { key, field, title, isInstall, payout }.
		// CPI/CPM => single line field=payout
		// CPA => cpa_payout_<index>
		payoutRows() {
			const id = this.r.id;
			if (this.r.payout_type === 'CPI' || this.r.payout_type === 'CPM') {
				return [
					{
						key: `${id}-payout`,
						field: 'payout',
						title: this.r.payout_type === 'CPM' ? 'CPM' : 'Install',
						isInstall: true,
						payout: this.r.payout,
					},
				];
			}
			return this.cpaFixedEventRows(this.r).map((row) => ({
				key: `${id}-cpa-${row.eventIndex}`,
				field: 'cpa_payout_' + row.eventIndex,
				title: row.name || '',
				isInstall: false,
				payout: row.payout,
			}));
		},
	},
	methods: {
		parsedOfferEvents(r) {
			return Array.isArray(r.events) ? r.events : [];
		},
		// CPA rows shown in the cell: only events with payout_mode fixed and payout > 0
		cpaFixedEventRows(r) {
			if (r.payout_type !== 'CPA') {
				return [];
			}
			const events = this.parsedOfferEvents(r);
			const rows = [];
			events.forEach((e, idx) => {
				if (e.payout_mode === 'fixed' && e.payout > 0) {
					rows.push({
						eventIndex: idx,
						payout: e.payout,
						name: (e.name && String(e.name).trim()) || '',
					});
				}
			});
			return rows;
		},
		onSave(row, field) {
			this.$emit('on-save', row, field);
		},
	},
};
</script>
